export const userNameValidator = value =>
  value && !/^[A-Z0-9._%+-]+$/i.test(value)
    ? 'Invalid value'
    : undefined;
